import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DmBreadcrumb, DmBreadcrumbItem } from '@digitale-menschen/component-library-angular';
import { LocalizedRouteService } from '../../services/localized-route.service';
import { LOCALIZED_SHARED_ROUTES } from '../../shared-route-const';
import { BreadcrumbEntry } from '../../models/breadcrumb-entry.model';

/** A page's breadcrumb trail, built from the entries the page hands over; links are localized here. */
@Component({
  selector: 'lp-page-breadcrumb',
  imports: [DmBreadcrumb, DmBreadcrumbItem, RouterLink],
  templateUrl: './page-breadcrumb.component.html',
})
export class PageBreadcrumbComponent {
  private readonly localizedRouteService = inject(LocalizedRouteService);

  public readonly entries = input.required<readonly BreadcrumbEntry[]>();

  protected readonly crumbs = computed<{ label: string; url: string | undefined }[]>(() =>
    this.entries().map((entry): { label: string; url: string | undefined } => ({
      label: entry.label,
      url: entry.link && this.buildUrl(entry.link),
    })),
  );

  private buildUrl(link: readonly (string | number)[]): string {
    const segments = link.map((segment) =>
      typeof segment === 'number' ? segment : this.localizedRouteService.getLocalizedRoute(LOCALIZED_SHARED_ROUTES[segment]),
    );
    return `/${segments.join('/')}`;
  }
}
